import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Box, Text, constants } from '@thecb/components';

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: fit-content(60%) 1fr 2fr;
  grid-gap: 16px;

  // Right align Quantity and Amount columns
  text-align: right;

  // Left align Item column
  div:nth-child(3n - 2) {
    text-align: left;
  }

  p {
    margin: 0px;
  }
`;

const LineItemGrid = ({ lineItems }) => (
  <GridContainer id="line-items-container">
    {lineItems.map((lineItem, index) => (
      <Fragment key={`li-${index}`}>
        <Box padding="0">
          <Text
            as="p"
            fontSize="p"
            weight={constants.fontWeights.FONT_WEIGHT_SEMIBOLD}
          >
            {lineItem.description}
          </Text>
          <Text
            as="p"
            fontSize="p"
            weight={constants.fontWeights.FONT_WEIGHT_REGULAR}
          >
            {lineItem.subDescription}
          </Text>
        </Box>
        <Text
          as="p"
          fontSize="p"
          weight={constants.fontWeights.FONT_WEIGHT_SEMIBOLD}
        >
          {`x ${lineItem.quantity}`}
        </Text>
        <Text
          as="p"
          fontSize="p"
          weight={constants.fontWeights.FONT_WEIGHT_SEMIBOLD}
        >
          {lineItem.amount}
        </Text>
      </Fragment>
    ))}
  </GridContainer>
);

export default LineItemGrid;
